export const reizersMap: { className: string }[] = [
	{ className: 'top-left' },
	{ className: 'top-right' },
	{ className: 'bottom-right' },
	{ className: 'bottom-left' }
];
